import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Container } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import Select from "react-select";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
} from "./resultSlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  colorsChart,
  createChangeHandler,
  formatDate,
  generateDatasetWithColors,
  getRandomColorChart,
  getValueStatus,
  handleSetOptionsMaster,
  paramsMasterAll,
  setOptionsMaster2,
  showErrorDialog,
} from "../../utility";

import {
  Doughnut,
  Bar,
  getDatasetAtEvent,
  getElementAtEvent,
  getElementsAtEvent,
  Pie,
} from "react-chartjs-2";

import {
  Chart as ChartJS,
  ArcElement,
  LinearScale,
  CategoryScale,
  BarElement,
  PointElement,
  LineElement,
  Legend,
  Tooltip,
  LineController,
  BarController,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

import { ResultTable } from "./ResultTable";
import { fetchParam2, selectDataParam2 } from "../param/paramSlice";
import { InputDateRange } from "../../utility/InputDateRange";
import { fetchUser, selectDataUser } from "../user/userSlice";

export const ResultSummary = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataParam2 = useSelector(selectDataParam2);
  const dataUser = useSelector(selectDataUser);

  // Register the elements you are using
  ChartJS.register(
    ChartDataLabels,
    ArcElement,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController
  );

  // Filter
  const [name, setName] = useState("");

  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(resetData());
      // You might want to fetch additional data here if necessary
    }
    fetchMyAPI();
  }, [dispatch]);

  const dataChart = [
    {
      question_desc: "Apakah Anda pernah membeli produk Kuppila?",
      question_type: "RADIO_BUTTON",
      question_answer: ["1", "2", "3"],
      question_option: [
        "ini ada lah 2",
        "ini adalah kelima ",
        "ini adalah ke 3",
      ],
      question_answer_total: "6",
    },
    {
      question_desc: "Apakah Anda pernah membeli produk Kuppila?",
      question_type: "DROPDOWN",
      question_answer: ["1", "2", "3"],
      question_option: [
        "ini ada lah a",
        "ini adalah kelima ",
        "ini adalah ke 3",
      ],
      question_answer_total: "6",
    },
    {
      question_desc: "Apakah Anda pernah membeli produk Kuppila?",
      question_type: "CHECKBOX",
      question_answer: ["1", "2", "3", "1", "2", "3", "1", "2", "3"],
      question_option: [
        "ini ada lah 2 CCC",
        "ini adalah kelima CCC",
        "ini adalah ke 3 CCC",
        "ini ada lah 2 CCC",
        "ini adalah kelima CCC",
        "ini adalah ke 3 CCC",
        "ini ada lah 2 CCC",
        "ini adalah kelima CCC",
        "ini adalah ke 3 CCC",
      ],
      question_answer_total: "6",
    },
    {
      question_desc: "Apakah Anda pernah membeli produk Kuppila?",
      question_type: "TEXT",
      question_answer: [
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
      ],
      question_option: [],
      question_answer_total: "6",
    },
    {
      question_desc: "Apakah Anda pernah membeli produk Kuppila?",
      question_type: "NUMBER",
      question_answer: [
        { text: "ini ada lah 1" },
        { text: " ini adalah 2" },
        { text: "ini adalah 3" },
      ],
      question_option: [],
      question_answer_total: "6",
    },
    {
      question_desc: "Apakah Anda pernah membeli produk Kuppila?",
      question_type: "FILE",
      question_answer: [
        { text: "ini ada lah 1", url: "https://www.google.com/" },
        { text: " ini adalah 2", url: "https://www.google.com/" },
        { text: "ini adalah 3", url: "https://www.google.com/" },
      ],
      question_option: [],
      question_answer_total: "6",
    },
  ];

  const optionsPie = {
    maintainAspectRatio: false,
    responsive: true,

    plugins: {
      legend: {
        // display: false,
        position: "bottom",
      },
      title: {
        display: true,
        align: "start",
        font: {
          size: 20,
        },
        style: "italic",
        padding: {
          top: 10,
          bottom: 30,
        },
        datalabels: {
          display: true,
          color: "white", // Set the text color to white
          align: "center",
          anchor: "center",
          formatter: function(value, context) {
            return value;
          },
        },
      },
    },
    z: {
      stacked: true,
    },
  };

  const optionsBar = {
    maintainAspectRatio: false,
    responsive: true,
    indexAxis: "y", // Membuat bar chart menjadi horizontal

    plugins: {
      legend: {
        display: false,
        position: "bottom",
      },
      title: {
        display: true,
        align: "start",
        font: {
          size: 20,
        },
        style: "italic",
        padding: {
          top: 10,
          bottom: 30,
        },
        datalabels: {
          display: true,
          color: "white", // Set the text color to white
          align: "center",
          anchor: "center",
          formatter: function(value, context) {
            return value;
          },
        },
      },
    },
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <Card>
      <CardHeader title="Summary Survey" />
      <CardBody>
        <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
          {dataChart.map((item, index) => {
            const {
              question_desc,
              question_type,
              question_answer,
              question_option,
              question_answer_total,
            } = item;

            console.log(dataChart, "dataChart");

            if (["DROPDOWN", "RADIO_BUTTON"].includes(question_type)) {
              const chartData = {
                labels: question_option,
                responsive: true,
                maintainAspectRatio: false,
                datasets: [
                  {
                    data: question_answer.map(Number),
                    backgroundColor: generateDatasetWithColors(question_answer),
                  },
                ],
              };

              return (
                <div
                  key={index}
                  style={{
                    padding: "20px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <h5>{question_desc}</h5>
                  <p>{question_answer_total} jawaban</p>
                  <div style={{ height: "30vh", position: "relative" }}>
                    <Pie data={chartData} options={optionsPie} />
                  </div>
                </div>
              );
            }
            if (["CHECKBOX"].includes(question_type)) {
              const chartData = {
                labels: question_option,
                responsive: true,
                maintainAspectRatio: false,
                datasets: [
                  {
                    data: question_answer.map(Number),
                    backgroundColor: generateDatasetWithColors(question_answer),
                  },
                ],
              };

              return (
                <div
                  key={index}
                  style={{
                    padding: "20px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <h5>{question_desc}</h5>
                  <p>{question_answer_total} jawaban</p>
                  <div style={{ height: "30vh", position: "relative" }}>
                    <Bar data={chartData} options={optionsBar} />
                    {/* <Pie data={chartData} options={optionsPie} /> */}
                  </div>
                </div>
              );
            }

            if (["TEXT", "NUMBER"].includes(question_type)) {
              return (
                <div
                  key={index}
                  style={{
                    padding: "20px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <h5>{question_desc}</h5>
                  <p>{question_answer.length} jawaban</p>
                  <ul
                    style={{
                      listStyleType: "none",
                      padding: "0",
                      maxHeight: "200px", // Batasi tinggi maksimal (sekitar 5 item tergantung ukuran)
                      overflowY: "auto", // Tambahkan scroll jika melebihi max-height
                      margin: "0",
                    }}
                  >
                    {question_answer.map((answer, idx) => (
                      <li
                        key={idx}
                        style={{
                          padding: "10px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        {answer.text}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            }

            if (["FILE"].includes(question_type)) {
              return (
                <div
                  key={index}
                  style={{
                    padding: "20px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <h5>{question_desc}</h5>
                  <p>{question_answer.length} jawaban</p>
                  <ul
                    style={{
                      listStyleType: "none",
                      padding: "0",
                      maxHeight: "200px", // Batasi tinggi maksimal (sekitar 5 item tergantung ukuran)
                      overflowY: "auto", // Tambahkan scroll jika melebihi max-height
                      margin: "0",
                    }}
                  >
                    {" "}
                    {question_answer.map((answer, idx) => (
                      <li
                        key={idx}
                        style={{
                          padding: "10px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <a
                          href={answer.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="nav-link px-3"
                        >
                          {answer.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            }

            return null;
          })}
        </div>
      </CardBody>
    </Card>
  );
};
